import React, { useContext, useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaCheckCircle, FaSadCry, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import buildLink from "../../../urls";
import { LogisticContext } from "../../../contexts/logisticContext";
import Loader from "../../../components/loader";
import MessageAlert from "../../../components/messageAlert";
import { PlaySounds } from "../../../functions/playSounds";
import { axiosServer } from "../../../axiosServer";
import hocStarredPage from "../../../components/hocStarredPage";

const ReceivingTransfer = () => {
  const transferId = useRef(null);
  const {playErrorSound,playSuccessSound} = PlaySounds();
  const [stateLogistic, dispatchStateLogistic] = useContext(LogisticContext);
  const [logisticSelect,setLogisticSelect] = useState(null);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [loading ,setLoading] = useState(false);

  const history = useNavigate();

  useEffect(() => {
    transferId.current.focus();
  }, []);
useEffect(()=>{
if(stateLogistic.logisticList.length>0){
  setLogisticSelect(stateLogistic.logisticList[14])
}
},stateLogistic.logisticList)


const getUserIdFromLocalStorage = () => {
  return localStorage.getItem("userID");
};

const updateTransfer = async (e = '') => {
  e.preventDefault();
  if (transferId.current.value == ""){
    setLoading(false);
    setMessage("Please Provide Transfer ID!");
    setShowMessageErr(true);
    playErrorSound();
    setTimeout(() => {
      setShowMessageErr(false);
    }, 3000);
    return;
  }

  setLoading(true);
  const userID = getUserIdFromLocalStorage();
  const url = buildLink("updateTransfer");
  const obj = {
    transfer_id: transferId.current.value,
    // logistic_id: logisticSelect.value,
    user_id: userID,
    type: "receiving",
  };
  
  try {
    const res = await axiosServer.put(url, obj);
    if (res.data.success) {
      setLoading(false);
      setMessage(res.data.message);
      setShowMessageSucc(true);
      playSuccessSound();
      setTimeout(() => {
        setShowMessageSucc(false);
      }, 3000);

      transferId.current.value = "";
      transferId.current.focus();
    } else {
      setLoading(false);
      // Enhanced error message with current status if available
      let errorMessage = res.data.message;
      if (res.data.data && res.data.data.current_status) {
        errorMessage += ` - Current Status: ${res.data.data.current_status}`;
      }
      setMessage(errorMessage);
      setShowMessageErr(true);
      playErrorSound();
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  } catch (e) {
    setLoading(false);
    let errorMessage = e.response?.data?.message || "An error occurred";
    // Enhanced error message with current status if available
    if (e.response?.data?.data?.current_status) {
      errorMessage += ` - Current Status: ${e.response.data.data.current_status}`;
    }
    setMessage(errorMessage);
    setShowMessageErr(true);
    playErrorSound();
    setTimeout(() => {
      setShowMessageErr(false);
    }, 3000);
  }
};






  const handleTrashClick = () => {
    transferId.current.value = "";
    transferId.current.focus();
  };

  return (
    <>
      <div className=" h-full bg-white">
    
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Receiving Transfer</h2>
            </div>
          </div>
        </div>
        <div className=" container">
        
          {/* <div className=" py-3">
            <div>logistics</div>
            <Select
            value={logisticSelect}
              placeholder="Logistics"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  outline: "red",
                  padding: "8px 5px",
                }),
              }}
              options={stateLogistic.logisticList}
              onChange={(e) => {
                setLogisticSelect(e);
              }}
            />
          </div>
           */}

          <div className="-mb-2">Transfer ID</div>
          <form
            onSubmit={(e) =>
              updateTransfer(e)
            }
            className="gap-2 flex py-3"
          >
            <div className="relative flex-1">
              <input
                ref={transferId}
                type="text"
                className="border-2 w-full rounded-md border-dbase py-2 pr-8 pl-2"
              />
              <FaTrash
                className="absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                onClick={handleTrashClick}
              />
            </div>
            <div className="w-fit cursor-pointer px-5 text-white text-center rounded-md bg-dbase">
              <button className="flex  whitespace-nowrap  items-center justify-center h-full">
              {loading ?  <Loader /> : "Send"}
              </button>
            </div>
          </form>
        </div>
    
        
        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};
export default hocStarredPage(ReceivingTransfer);